import { EyeIcon } from '@heroicons/react/16/solid';
import { ColumnHeader } from '@src/components/Table/components';
import { Referral } from '@src/services/affiliate/affiliateApiSliceTypes';
import { SortDirection } from '@src/types/common';
import { cleanNumberDisplay, getCurrencySymbol } from '@src/utilities/currency';
import dayjs from 'dayjs';
import { TFunction } from 'i18next';

interface RenderColumnsProps {
  t: TFunction;
  onDetails: (item: Referral) => void;
  sorterState?: {
    sortBy: string | null;
    sortOrder: SortDirection | null;
    onSortChange: (columnKey: string, order: SortDirection | null) => void;
  };
}

export function RenderColumns({
  t,
  sorterState,
  onDetails,
}: RenderColumnsProps) {
  const baseColumns = [
    {
      key: 'email',
      dataIndex: 'email',
      title: t('pages.affiliate.referrals.dataTable.email'),
    },
    {
      key: 'signUpDate',
      dataIndex: 'signUpDate',
      title: t('pages.affiliate.referrals.dataTable.signUpDate'),
      sortable: false,
      render: (_, item) => {
        return dayjs(item.signUpDate).format('MM/DD/YYYY - HH:mm A');
      },
    },
    {
      key: 'totalCommission',
      dataIndex: 'totalCommission',
      title: t('pages.affiliate.referrals.dataTable.totalCommission'),
      render: (_, item) => {
        return `${getCurrencySymbol('EUR')} ${cleanNumberDisplay(item.totalCommission)}`;
      },
    },
    {
      key: 'details',
      dataIndex: 'details',
      title: t('pages.affiliate.referrals.dataTable.details'),
      render: (_, item) => {
        return (
          <EyeIcon
            onClick={() => onDetails(item)}
            width={20}
            className='text-wl-primary cursor-pointer'
          />
        );
      },
    },
  ];

  const equalWidth = `${100 / baseColumns.length}%`;

  const enhancedColumns = [
    ...baseColumns.map((col) => ({
      ...col,
      width: equalWidth,
      title: (
        <ColumnHeader
          title={col.title}
          columnKey={col.dataIndex}
          sortable={!!col.sortable}
          sortOrder={
            sorterState?.sortBy === col.key ? sorterState.sortOrder : null
          }
          onSortChange={(order) => sorterState?.onSortChange(col.key, order)}
        />
      ),
    })),
  ];

  return enhancedColumns;
}
